import React, { useState } from 'react';
import './Classes.css';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner/PageBanner';
import { apiCall, API_URL } from '../utils/api';

import {
  FaLeaf,
  FaFire,
  FaStar,
  FaHeart,
  FaSpa,
  FaChild
} from "react-icons/fa";

import { useLanguage } from '../contexts/LanguageContext';

import yoga4 from '../assets/images/y4.jpg';
import yoga5 from '../assets/images/y5.jpg';
import yoga10 from '../assets/images/y10.jpg';
import pregnancy from '../assets/images/pregnency.png';
import urja from '../assets/images/urja.png';
import e1 from '../assets/images/e1.avif';
import e2 from '../assets/images/e2.webp';
import e3 from '../assets/images/e3.jpg';

function Classes() {
  const { t } = useLanguage();

  const servicePrograms = [
    { id: 1, name: 'Yoga at Your Home', imageUrl: yoga4 },
    { id: 2, name: 'Online Yoga', imageUrl: yoga5 },
    { id: 3, name: 'Yoga Studio', imageUrl: yoga10 },
    { id: 4, name: 'Corporate Yoga', imageUrl: pregnancy },
    { id: 5, name: 'Pregnancy Yoga', imageUrl: urja },
    { id: 6, name: 'Meditation Magic', imageUrl: e1 },
    { id: 7, name: 'Positive Instruction', imageUrl: e2 },
    { id: 8, name: 'Stress Relief', imageUrl: e3 },
  ];

  return (
    <div className="classes">

      {/* Dynamic Page Banner from Admin */}
      <PageBanner pageKey="classes" />

      {/* Class Cards */}
      <section className="class-cards-section">
        <div className="container">
          <div className="class-cards-grid">

            {servicePrograms.map((program) => (
              <div key={program.id} className="class-card reveal tilt zoom">
                <div className="class-card-image">
                  <img
                    src={program.imageUrl}
                    alt={program.name}
                  />
                </div>
                <div className="class-card-content">
                  <h3 className="class-name fade-in" style={{ textAlign: "center", marginBottom: "15px" }}>{program.name}</h3>
                  <Link to="/booking" className="class-btn glow-btn btn-shimmer">
                    {t('classes.booking_btn')}
                  </Link>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="cta-section reveal">
        <div className="container">
          <h2 className="zoom">{t('classes.cta.title')}</h2>
          <p className="fade-in">{t('classes.cta.desc')}</p>
          <a href="/booking" className="btn btn-primary btn-large btn-shimmer">
            {t('classes.cta.btn')}
          </a>
        </div>
      </section>

    </div >
  );
}

export default Classes;
